module.exports = __webpack_public_path__ + "static/2-1c7bfb243c8aa5a513d1fb209bfea400.jpg";